import React from 'react'
import Gradient from './Gradient'


export const GradientPanel = props => {
    return(
        <div className="row">
            <div className="col-sm-4 col-xs-8 gradientPanel">
                <div style={{display: "flex", "text-align": "center"}}>
                    <span>Air Quality Index</span>
                </div>
                <Gradient/>
            </div>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/Map/BettAppBar/GradientPanel.js